import { render, staticRenderFns } from "./GeneralDetailsInputs.vue?vue&type=template&id=7df0d3cd&"
import script from "./GeneralDetailsInputs.vue?vue&type=script&lang=js&"
export * from "./GeneralDetailsInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports